import {gql} from 'apollo-angular';

export default gql`
mutation ForgotPassword($input: ForgotPasswordInput) {
  forgotPassword(input:$input)
}
`;
